import {Signal, WritableSignal} from "@angular/core";
import {NetworkAudioInputChannel} from "@models";

export class AudioDevice {
	deviceId: string;
	groupId: string;
	label: string;

	isDefault: boolean = false;

	constructor(deviceId: string, groupId: string, label: string) {
		this.deviceId = deviceId;
		this.groupId = groupId;
		this.label = label;
	}

	public isSameAs(other: AudioDevice): boolean {
		return this.deviceId === other?.deviceId && this.groupId === other?.groupId;
	}
}

export type AudioClientMode = "browser" | "network-audio-client";

export interface IAudioClientService {
	readonly connected: Signal<boolean>;
	readonly selectedAudioDevice: Signal<AudioDevice>;
	readonly audioDevices: Signal<AudioDevice[]>;
	//0-1
	readonly volume: WritableSignal<number>;
	readonly muted: WritableSignal<boolean>;
	readonly supportsVisualizer: boolean;
	readonly supportsVolumeControl: boolean;

	reloadAudioDevices(): Promise<void>;

	setAudioDevice(audioDevice: AudioDevice): Promise<boolean>;

	startVisualizer(canvas: HTMLCanvasElement): Promise<boolean>;

	stopVisualizer(): Promise<boolean>;

	startSending(channel: NetworkAudioInputChannel): Promise<boolean>;

	stopSending(): Promise<boolean>;
}
